import React from 'react';

import css from './CustomTopBar.module.css';
import IconCamping from '../../assets/icon-camping.svg';
import IconCycling from '../../assets/icon-cycling.svg';
import IconWaterSports from '../../assets/icon-water-sports.svg';
import IconHiking from '../../assets/icon-hiking.svg';
import IconSnowSports from '../../assets/icon-snow-sports.svg';

const data = [
  {
    icon: IconCamping,
    label: 'Camping Gear',
    link: '/s?pub_categoryLevel1=camping-gear-id',
  },
  {
    icon: IconWaterSports,
    label: 'Water Sports',
    link: '/s?pub_categoryLevel1=water-sports-id',
  },
  {
    icon: IconSnowSports,
    label: 'Snow Sports',
    link: '/s?pub_categoryLevel1=snow-sports-id',
  },
  {
    icon: IconHiking,
    label: 'Hiking Gear',
    link: '/s?pub_categoryLevel1=hiking-gear-id',
  },
  {
    icon: IconCycling,
    label: 'Cycling Gear',
    link: '/s?pub_categoryLevel1=cycling-gear-id',
  },
];

export default function CustomTopBar() {
  return (
    <div className={css.customTopBarContainer}>
      <div className={css.customTopBarLinks}>
        {data.map(item => (
          <a key={item.label} href={item.link} className={css.customTopBarLink}>
            <img src={item.icon} alt={item.label} />
            <span>{item.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
